import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography, TextField, Alert } from '@mui/material';
import CommonButton from '../../components/atom/CommonButton';
import { publicConnectOnboarding } from '@openapi/payment-methods/payment-methods';

function ConnectOnboardingPage() {
    const { venueSlug, paymentMethodId, hash } = useParams();
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleStart = async () => {
        if (!email) {
            setError('Please enter an email address');
            return;
        }
        setLoading(true);
        setError(null);

        try {
            const data = await publicConnectOnboarding(venueSlug, Number(paymentMethodId), hash, {
                email,
                returnUrl: window.location.href + '?done=1',
                refreshUrl: window.location.href,
            });
            if (data.onboardingUrl) {
                window.location.href = data.onboardingUrl;
            } else {
                setError('Failed to start onboarding');
            }
        } catch {
            setError('Failed to connect. Please try again.');
        }
        setLoading(false);
    };

    if (window.location.search.includes('done=1')) {
        return (
            <Box sx={{ maxWidth: 500, mx: 'auto', mt: 8, p: 3 }}>
                <Alert severity="success">
                    Stripe Connect onboarding completed. You can close this page.
                </Alert>
            </Box>
        );
    }

    return (
        <Box sx={{ maxWidth: 500, mx: 'auto', mt: 8, p: 3 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
                Stripe Connect Onboarding
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Enter your email to begin connecting your Stripe account for receiving payments.
            </Typography>
            <TextField
                fullWidth
                label="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                sx={{ mb: 2 }}
            />
            {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    {error}
                </Alert>
            )}
            <CommonButton
                fullWidth
                label={loading ? 'Starting...' : 'Start Onboarding'}
                buttonType="primary"
                disabled={loading}
                onClick={handleStart}
            />
        </Box>
    );
}

export default ConnectOnboardingPage;
